export default "/static/build/premium.png";